import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, Star } from "lucide-react";
import { PACKAGES } from "@/lib/data";

export const PackagesGrid = () => (
  <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4" data-testid="packages-grid">
    {PACKAGES.map((p, i) => (
      <motion.div
        key={p.name}
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: i * 0.1 }}
        className={`relative flex flex-col rounded-2xl p-8 border transition-transform duration-300 hover:-translate-y-2 ${p.featured ? "bg-crate-yellow text-crate-black border-crate-yellow" : "bg-crate-surface text-white border-white/10 hover:border-crate-yellow"}`}
        data-testid={`package-card-${p.name.toLowerCase().replace(/ /g, "-")}`}
      >
        {p.featured && (
          <span className="absolute -top-3 left-8 inline-flex items-center gap-1 rounded-full bg-crate-black text-crate-yellow text-xs font-bold px-3 py-1">
            <Star className="h-3 w-3 fill-crate-yellow" /> Most Popular
          </span>
        )}
        <h3 className="font-heading font-bold text-2xl">{p.name}</h3>
        <p className={`text-sm mt-1 ${p.featured ? "text-crate-black/70" : "text-white/50"}`}>{p.desc}</p>
        <div className="mt-6 flex items-end gap-1">
          {p.price === "Quote" ? (
            <span className="font-heading font-black text-4xl">Custom</span>
          ) : (
            <>
              <span className="font-heading font-black text-5xl">${p.price}</span>
              <span className={`mb-2 text-sm ${p.featured ? "text-crate-black/60" : "text-white/50"}`}>/{p.period.split(" ")[0]}{p.period.split(" ")[1] ? "" : ""}</span>
            </>
          )}
        </div>
        <span className={`mt-1 text-sm font-semibold ${p.featured ? "text-crate-black/70" : "text-crate-yellow"}`}>{p.totes} · {p.period}</span>

        <ul className="mt-6 space-y-3 flex-1">
          {p.features.map((f) => (
            <li key={f} className="flex items-start gap-2.5 text-sm">
              <Check className={`h-4 w-4 mt-0.5 shrink-0 ${p.featured ? "text-crate-black" : "text-crate-yellow"}`} />
              <span className={p.featured ? "text-crate-black/80" : "text-white/70"}>{f}</span>
            </li>
          ))}
        </ul>

        <Link
          to="/reserve"
          data-testid={`package-reserve-${p.name.toLowerCase().replace(/ /g, "-")}`}
          className={`mt-8 rounded-full font-bold px-6 py-3 text-center transition-colors ${p.featured ? "bg-crate-black text-white hover:bg-crate-black/80" : "bg-crate-yellow text-crate-black hover:bg-white"}`}
        >
          {p.price === "Quote" ? "Get a Quote" : "Reserve"}
        </Link>
      </motion.div>
    ))}
  </div>
);
